import { createFileRoute } from "@tanstack/react-router";
import Parts from "@/pages/Parts";

const TITLE = "RV Parts & Accessories | Rex & Sons RVs";
const DESCRIPTION =
  "Shop RV parts and accessories at Rex & Sons RVs in Castle Hayne, NC — appliances, electrical, towing, plumbing, furniture and everyday camping supplies.";
const URL = "https://www.rexandsonsrvs.com/rv-parts";
const IMAGE = "https://www.myrvpart.com/images/splash-assets/hero-parts-1920.webp";

export const Route = createFileRoute("/rv-parts")({
  component: Parts,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: URL },
      { property: "og:image", content: IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
      { name: "twitter:image", content: IMAGE },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
});
